import './App.scss';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './Layout/Layout.jsx';
import { Home } from './pages/Home/Home.jsx';
import { About } from './pages/About/About.jsx';
import { BlancoDeCazador } from './pages/BlancoDeCazador/BlancoDeCazador.jsx';
import { Projects } from './pages/Projects/Projects.jsx';
import { Contact } from './pages/Contact/Contact.jsx';
import { NotFound } from './pages/NotFound/NotFound';
import { Project } from './pages/Project/Project';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { Studio } from './pages/Studio/Studio';

import { ProjectList } from './pages/ProjectList/ProjectList';
import { AboutCategoriesList } from './pages/AboutCategoriesList/AboutCategoriesList.jsx';
import { CreateAndUpdateStudio } from './pages/CreateAndUpdateStudio/CreateAndUpdateStudio.jsx';
import { StudioCategoriesList } from './pages/StudioCategoriesList/StudioCategoriesList.jsx';
import { AboutCompuesto } from './pages/AboutCompuesto/AboutCompuesto.jsx';
import { CreateAndUpdateBDC } from './pages/CreateAndUpdateBDC/CreateAndUpdateBDC.jsx';
import { BDCCategoriesList } from './pages/BDCCategoriesList/BDCCategoriesList.jsx';
import { CreateAndUpdateAbout } from './pages/CreateAndUpdateAbout/CreateAndUpdateAbout.jsx';
import { CreateAndUpdateProject } from './pages/CreateAndUpdateProject/CreateAndUpdateProject.jsx';
import Login from './pages/Login/Login';

function App() {
	const token = localStorage.getItem('token');

	return (
		<div className='App'>
			<BrowserRouter
				future={{
					v7_startTransition: true,
					v7_relativeSplatPath: true,
				}}
			>
				<Routes>
					<Route path='/' element={<Layout />}>
						{/* Rutas privadas */}
						{token && (
							<>
								{/* Proyectos */}
								<Route
									path='/create-project'
									element={<CreateAndUpdateProject />}
								/>
								<Route
									path='/list-projects'
									element={<ProjectList />}
								/>
								<Route
									path='/edit-project/:id'
									element={<CreateAndUpdateProject />}
								/>

								{/* About */}
								<Route
									path='/create-category-about'
									element={<CreateAndUpdateAbout />}
								/>
								<Route
									path='/list-categories-about'
									element={<AboutCategoriesList />}
								/>
								<Route
									path='/edit-aboutCategory/:id'
									element={<CreateAndUpdateAbout />}
								/>

								{/* Studio */}
								<Route
									path='/create-category-studio'
									element={<CreateAndUpdateStudio />}
								/>
								<Route
									path='/list-categories-studio'
									element={<StudioCategoriesList />}
								/>
								<Route
									path='/edit-studioCategory/:id'
									element={<CreateAndUpdateStudio />}
								/>

								{/* BDC */}
								<Route
									path='/create-category-bdc'
									element={<CreateAndUpdateBDC />}
								/>
								<Route
									path='/list-categories-bdc'
									element={<BDCCategoriesList />}
								/>
								<Route
									path='/edit-bdcCategory/:id'
									element={<CreateAndUpdateBDC />}
								/>

								{/* Dashboard */}
								<Route
									path='/dashboard'
									element={<Dashboard />}
								/>
								<Route
									path='/login'
									element={
										<Navigate replace to='/dashboard' />
									}
								/>
							</>
						)}

						{/* Rutas públicas */}
						<Route index element={<Home />} />
						<Route path='/about' element={<About />} />
						<Route
							path='/blancodecazador'
							element={<BlancoDeCazador />}
						/>
						<Route
							path='/about-compuesto'
							element={<AboutCompuesto />}
						/>
						<Route path='/projects' element={<Projects />} />
						<Route path='/contact' element={<Contact />} />
						<Route path='/studio' element={<Studio />} />
						<Route path='/:id' element={<Project />} />
						<Route path='/login' element={<Login />} />
						<Route
							path='/dashboard'
							element={<Navigate replace to='/login' />}
						/>
						<Route
							path='/edit-project/:id'
							element={<Navigate replace to='/login' />}
						/>
						<Route
							path='/edit-aboutCategory/:id'
							element={<Navigate replace to='/login' />}
						/>
						<Route path='*' element={<NotFound />} />
					</Route>
				</Routes>
			</BrowserRouter>
		</div>
	);
}

export default App;
